/**
 * Mirrors App\Support\ProjectMaintenance on the client.
 */
export function isSiteUnderMaintenance() {
    if (typeof window === 'undefined') return false;
    if (window.__MAINTENANCE_APPLIES__ === false) return false;

    const data = window.__APP_DATA__;
    if (!data) return false;
    if (data.siteMaintenance === true) return true;

    return data.project?.deployed === false;
}

export function applyMaintenanceDocumentState() {
    if (typeof document === 'undefined') return;
    document.documentElement.classList.add('app-ready', 'site-maintenance');
    document.body?.classList.add('site-maintenance');
}

let splashRemovalScheduled = false;

function removeSplashNode() {
    const node = document.getElementById('app-splash');
    if (node && node.parentNode) {
        node.parentNode.removeChild(node);
    }
}

function scheduleSplashRemoval() {
    if (splashRemovalScheduled) return;
    splashRemovalScheduled = true;
    setTimeout(removeSplashNode, 400);
}

/**
 * Does not reveal the page. The stylesheet script in
 * resources/views/injections/head.blade.php is the only path that adds
 * `app-ready`. Once that class exists, the splash node is removed.
 */
export function markAppReady() {
    if (typeof document === 'undefined') return;
    if (!document.documentElement.classList.contains('app-ready')) return;
    scheduleSplashRemoval();
}

/**
 * Splash overlay reveal — see resources/views/injections/head.blade.php.
 * This does not wait for fonts, islands, or a success timer.
 */
export function initSplashOverlay() {
    if (typeof window === 'undefined' || typeof document === 'undefined') return;

    const html = document.documentElement;
    if (html.classList.contains('app-ready')) {
        scheduleSplashRemoval();
        return;
    }

    const observer = new MutationObserver(() => {
        if (!html.classList.contains('app-ready')) return;
        observer.disconnect();
        scheduleSplashRemoval();
    });
    observer.observe(html, { attributes: true, attributeFilter: ['class'] });
}
